import React from "react";
import {useLoginPopup} from "hooks/useLoginPopup";

export const withLoginPopup = (Component: any) => {
  return React.forwardRef(function WithLoginPopup(props: any, ref) {
    const showLoginPopup = useLoginPopup();
    return <Component ref={ref} showLoginPopup={showLoginPopup} {...props} />;
  });

};